module.exports = __webpack_public_path__ + "media/images/carts/empty-dd8f3b616de639c01b8c98fa5adda49f.svg";